"use client"; // Ensure this directive is present

import React from 'react';

// Data for the banner
const bannerData = {
    title: 'Promotional Solutions for Every Business Need',
    date: 'Our Products & Services',
    address: 'Discover our wide range of customizable products designed to elevate your brand and make lasting impressions. Contact us to discuss your specific needs.',
    buttonLink: '/contact', // Update this link as necessary
};

export default function BannerOne() {
    return (
        <section id="th-home" className="banner-one">
            <div className="banner-one__video-bg">
                <video 
                    autoPlay 
                    muted 
                    loop 
                    playsInline
                    className="banner-one__video"
                >
                    <source src="/hero2.mp4" type="video/mp4" />
                    Your browser does not support the video tag.
                </video>
            </div>
            <div className="container">
                <div className="banner-one__inner">
                    <h2 className="banner-one__title wow fadeInLeft" data-wow-delay="200ms">{bannerData.title}</h2>
                    <p className="banner-one__date wow fadeInRight" data-wow-delay="300ms">{bannerData.date}</p>
                    <p className="banner-one__address wow fadeInLeft" data-wow-delay="400ms">{bannerData.address}</p>
                    <div className="banner-one__btn-box wow fadeInRight" data-wow-delay="400ms">
                        <a href={bannerData.buttonLink} className="banner-one__btn thm-btn">Get Started <span className="icon-arrow-right"></span></a>
                    </div>
                </div>
            </div>
        </section>
    );
}
